import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import Sidebar from 'features/IRWorkstation/components/Sidebar';
import KPICard from 'features/IRWorkstation/components/KPICard';
import QuadPanel from 'features/IRWorkstation/components/QuadPanel';
import ActiveRaiseContent from 'features/IRWorkstation/components/ActiveRaiseContent';
import AlertsWidget from 'features/IRWorkstation/components/AlertsWidget';
import WorkQueueWidget from 'features/IRWorkstation/components/WorkQueueWidget';
import NewsFeedWidget from 'features/IRWorkstation/components/NewsFeedWidget';
import fakeData from 'features/IRWorkstation/constants/fakeData';

const Overview = ({
	onOpenAlertsDrawer,
	onOpenTaskDrawer,
	onOpenNewsFeedDrawer,
	onOpenFundV,
}) => {
	const { overviewKPIs, pageHeader } = fakeData;

	return (
		<Box sx={{ display: 'flex', flex: 1, minHeight: 0 }}>
			<Sidebar />

			{/* main content */}
			<Box
				sx={{
					flex: 1,
					minWidth: 0,
					overflowY: 'auto',
					backgroundColor: 'background.default',
					padding: '12px 20px',
					display: 'flex',
					flexDirection: 'column',
					gap: '14px',
				}}
			>
				{/* page header */}
				<Box
					sx={{
						display: 'flex',
						alignItems: 'baseline',
						justifyContent: 'space-between',
					}}
				>
					<Typography sx={{ fontSize: '17px', fontWeight: 700 }}>
						{pageHeader.title}
					</Typography>
					<Typography sx={{ fontSize: '12px', color: 'text.secondary' }}>
						{pageHeader.meta}
					</Typography>
				</Box>

				{/* kpi strip */}
				<Box
					sx={{
						display: 'grid',
						gridTemplateColumns: 'repeat(6, 1fr)',
						gap: '10px',
					}}
				>
					{overviewKPIs.map((kpi) => (
						<KPICard key={kpi.label} {...kpi} />
					))}
				</Box>

				{/* quad grid */}
				<Box
					sx={{
						display: 'grid',
						gridTemplateColumns: '1fr 1fr',
						gridTemplateRows: '1fr 1fr',
						gap: '10px',
						flex: 1,
						minHeight: 0,
					}}
				>
					{/* work queue */}
					<WorkQueueWidget onOpenTaskDrawer={onOpenTaskDrawer} />

					{/* alerts */}
					<AlertsWidget onOpenAlertsDrawer={onOpenAlertsDrawer} />

					{/* news feed */}
					<NewsFeedWidget onOpenNewsFeedDrawer={onOpenNewsFeedDrawer} />

					{/* active raise */}
					<QuadPanel
						title='Active raise — Fund V'
						tryIt
						badge='Watch · 41 days'
						badgeColor='amber'
						subtitle={
							<>
								VDR Status column live from Raise VDR ·{' '}
								<Box
									component='span'
									sx={{
										fontSize: '10px',
										fontWeight: 600,
										color: 'vdr.text',
										backgroundColor: 'vdr.bg',
										border: '0.5px solid',
										borderColor: 'vdr.border',
										borderRadius: '3px',
										padding: '2px 6px',
										cursor: 'pointer',
										'&:hover': { backgroundColor: 'vdr.hover' },
									}}
								>
									↔ Open Raise VDR
								</Box>
							</>
						}
					>
						<ActiveRaiseContent onOpenFundV={onOpenFundV} />
					</QuadPanel>
				</Box>
			</Box>
		</Box>
	);
};

Overview.propTypes = {
	onOpenAlertsDrawer: PropTypes.func.isRequired,
	onOpenTaskDrawer: PropTypes.func.isRequired,
	onOpenNewsFeedDrawer: PropTypes.func.isRequired,
	onOpenFundV: PropTypes.func.isRequired,
};

export default Overview;
